import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "card-info-container"
}

import { ICardInfo } from '@/interfaces';

export default /*@__PURE__*/_defineComponent({
  __name: 'CardInfoContainer',
  props: {
    info: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.info)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Cartão (final " + _toDisplayString(_ctx.info.card_last_digits) + ")", 1))
    : _createCommentVNode("", true)
}
}

})